import { useState } from "react";
import { type EditorOps } from "./editorCore";

export const useLevels = (ops: EditorOps, setOps: (ops: EditorOps) => void) => {
  const [levels, setLevels] = useState(
    ops.niveles ?? { black: 0, mid: 128, white: 255 }
  );

  const handleChange = (key: "black" | "mid" | "white", value: number) => {
    const newLevels = { ...levels, [key]: value };
    setLevels(newLevels);
    setOps({ ...ops, niveles: newLevels });
  };

  const reset = () => {
    const resetLevels = { black: 0, mid: 128, white: 255 };
    setLevels(resetLevels);
    setOps({ ...ops, niveles: undefined });
  };

  const control = (
    <div>
      <label>Negros</label>
      <input
        type="range"
        min={0}
        max={255}
        value={levels.black}
        onChange={(e) => handleChange("black", +e.target.value)}
      />
      <label>Medios</label>
      <input
        type="range"
        min={0}
        max={255}
        value={levels.mid}
        onChange={(e) => handleChange("mid", +e.target.value)}
      />
      <label>Blancos</label>
      <input
        type="range"
        min={0}
        max={255}
        value={levels.white}
        onChange={(e) => handleChange("white", +e.target.value)}
      />
      <button className="btn btn-default" onClick={reset}>
        Reset
      </button>
    </div>
  );

  return {
    control,
    onMouseDown: undefined,
    onMouseMove: undefined,
    onMouseUp: undefined,
    renderOverlay: undefined,
  };
};
